/**
 * component-product-image-slider.js
 * Upload to: /assets/component-product-image-slider.js
 */
(function () {
  'use strict';
 
  var SWIPE = 40;
  var MAX_IMAGES = 5;
  var cache = {};
 
  function fetchImages(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        // Return raw CDN base URLs — we'll build srcsets from these
        return (d.images || []).slice(0, MAX_IMAGES).map(function (url) {
          if (url.indexOf('//') === 0) url = 'https:' + url;
          return url; // keep original URL as-is
        });
      })
      .catch(function () { return []; });
    return cache[handle];
  }
 
  // Build a srcset string from a Shopify CDN image URL
  // matching the same widths the theme uses
  function buildSrcset(url) {
    var widths = [165, 360, 535, 750, 940, 1100];
    return widths.map(function (w) {
      var sized = url.replace(/\.(jpg|jpeg|png|gif|webp)(\?)/i, '_' + w + 'x.$1$2')
                     .replace(/\.(jpg|jpeg|png|gif|webp)$/i,    '_' + w + 'x.$1');
      return sized + ' ' + w + 'w';
    }).join(', ');
  }
 
  function buildSrc(url) {
    return url.replace(/\.(jpg|jpeg|png|gif|webp)(\?)/i, '_800x.$1$2')
              .replace(/\.(jpg|jpeg|png|gif|webp)$/i,    '_800x.$1');
  }
 
  function buildSlider(card, images) {
    if (images.length < 2) return;
 
    var ri = card.querySelector('responsive-image');
    if (!ri || ri.dataset.pisReady) return;
 
    var img = ri.querySelector('img');
    if (!img) return;
 
    ri.dataset.pisReady = 'true';
    ri.classList.add('pis-ready');
 
    // Snapshot ALL original img attributes — restore on index 0
    var origSrc    = img.src;
    var origSrcset = img.getAttribute('srcset') || '';
    var origSizes  = img.getAttribute('sizes')  || '';
    var origWidth  = img.getAttribute('width')  || '';
    var origHeight = img.getAttribute('height') || '';
 
    // Arrows
    var prevBtn = makeBtn('<polyline points="15 18 9 12 15 6"/>', 'pis-arrow pis-arrow--prev', 'Previous image');
    var nextBtn = makeBtn('<polyline points="9 18 15 12 9 6"/>',  'pis-arrow pis-arrow--next', 'Next image');
    ri.appendChild(prevBtn);
    ri.appendChild(nextBtn);
 
    // Dots
    var total = images.length;
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'pis-dots';
    var dots = [];
    for (var j = 0; j < total; j++) {
      var dot = document.createElement('button');
      dot.className = 'pis-dot' + (j === 0 ? ' pis-dot--active' : '');
      dot.type = 'button'; dot.dataset.i = j;
      dot.setAttribute('aria-label', 'Image ' + (j + 1));
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    ri.appendChild(dotsWrap);
 
    var cur = 0;
 
    function goTo(idx) {
      if (idx === cur || idx < 0 || idx >= total) return;
 
      img.classList.add('pis-fade');
 
      var newSrc    = idx === 0 ? origSrc    : buildSrc(images[idx]);
      var newSrcset = idx === 0 ? origSrcset : buildSrcset(images[idx]);
      var newSizes  = idx === 0 ? origSizes  : origSizes; // keep same sizes
      var newWidth  = idx === 0 ? origWidth  : origWidth;
      var newHeight = idx === 0 ? origHeight : origHeight;
 
      setTimeout(function () {
        // Set width/height FIRST to prevent layout shift
        if (newWidth)  img.setAttribute('width',  newWidth);
        if (newHeight) img.setAttribute('height', newHeight);
        if (newSizes)  img.setAttribute('sizes',  newSizes);
        img.setAttribute('srcset', newSrcset);
        img.src = newSrc;
        img.classList.remove('pis-fade');
      }, 150);
 
      dots[cur].classList.remove('pis-dot--active');
      dots[idx].classList.add('pis-dot--active');
      cur = idx;
    }
 
    prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo((cur - 1 + total) % total); });
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo((cur + 1) % total); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(+dot.dataset.i); });
    });
 
    // Touch swipe
    var sx = 0, sy = 0, drag = false, horiz = null;
    ri.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      drag = true; horiz = null;
    }, { passive: true });
    ri.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (horiz === null) horiz = Math.abs(dx) > Math.abs(dy);
      if (horiz) e.preventDefault();
    }, { passive: false });
    ri.addEventListener('touchend', function (e) {
      if (!drag || !horiz) { drag = false; return; }
      drag = false;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) >= SWIPE) goTo(dx < 0 ? (cur + 1) % total : (cur - 1 + total) % total);
    }, { passive: true });
 
    ri.addEventListener('mouseenter', function () {
      // Preload image 2
      var pre = new Image();
      pre.src = buildSrc(images[1]);
    }, { once: true });
  }
 
  function makeBtn(poly, cls, label) {
    var b = document.createElement('button');
    b.className = cls; b.type = 'button';
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' + poly + '</svg>';
    return b;
  }
 
  function initCards(root) {
    (root || document).querySelectorAll('.m-product-item:not([data-pis-init])').forEach(function (item) {
      item.setAttribute('data-pis-init', '1');
      var a = item.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1], done = false;
 
      function init() {
        if (done) return; done = true;
        fetchImages(handle).then(function (imgs) { buildSlider(item, imgs); });
      }
 
      item.addEventListener('mouseenter', init, { once: true });
 
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { init(); io.disconnect(); }
        }, { rootMargin: '200px' });
        io.observe(item);
      }
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }
 
  var c = document.querySelector('[data-product-container]');
  if (c) new MutationObserver(function () { initCards(c); }).observe(c, { childList: true });
  document.addEventListener('shopify:section:load', function () { initCards(); });
  window.ProductImageSlider = { init: initCards };
})();